import {Editor, Element, Transforms, type Path} from "slate";

/**
 * Searches the editor for a skeleton-block with the given placeholder key,
 * and returns its path if found. Returns undefined if no matching skeleton
 * is found.
 */
export const getSkeletonPathByPlaceholderKey = (
    editor: Editor,
    placeholderKey: string,
): Path | undefined => {
    const [skeleton] = Editor.nodes(editor, {
        match: (n) =>
            !Editor.isEditor(n) &&
            Element.isElement(n) &&
            n.type === "skeleton-block" &&
            n.placeholderKey === placeholderKey,
        at: [],
    });
    if (!skeleton) {
        return;
    }

    return skeleton[1];
};

/**
 * Clears a skeleton-block from the editor with the given placeholder key.
 * This can be used to, for example, display a section as "done" when
 * the backend has finished a completion that we had a placeholder for.
 */
export const clearSkeletonWithPlaceholderKey = (
    editor: Editor,
    placeholderKey: string,
) => {
    Transforms.removeNodes(editor, {
        match: (n) =>
            Element.isElement(n) &&
            n.type === "skeleton-block" &&
            n.placeholderKey === placeholderKey,
        at: [],
    });
};

/**
 * Clears all skeleton-blocks from the editor. This can be used to remove
 * all displayed placeholders from a document when all intermediate completions
 * have finished.
 */
export const clearAllSkeletons = (editor: Editor) => {
    Transforms.removeNodes(editor, {
        match: (n) => Element.isElement(n) && n.type === "skeleton-block",
        at: [],
    });
};
